module.exports = __webpack_public_path__ + "static/media/certified.dd91f005.png";